import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'

@Component({
    selector: 'app-audit',
    templateUrl: './audit.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './audit.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class AuditComponent implements OnInit {
    accessLog = 'hidden'
    accessAuditActive = ''
    accountAuditActive = ''
    accountLog = 'hidden'
    clientInfo: any
    listAccessLog: any
    listStaffAccessLog: any
    resourceUrl = 'resource'
    list: any
    listAccountLog: any
    listStaffAccountLog: any
    en = {}
    showEN = true
    idClient
    operatorNameClient

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private route: ActivatedRoute) {
        this.accessLog = 'active'
        this.accessAuditActive = 'accessAuditActive'
    }

    ngOnInit() {
        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idClient = id
        })
        this.mainClient()
    }

    mainClient() {
        this.callApiTabAccessLog(this.idClient)
    }

    selectAccessDetail(accessLogDetail) {
        this._sharedService.emitChange(accessLogDetail)
    }

    selectAccountDetail(accountLogDetail) {
        this._sharedService.emitChange(accountLogDetail)
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }


    selectTabAccessLog() {
        this.accessLog = 'active'
        this.accountLog = 'hidden'
        this.accessAuditActive = 'accessAuditActive'
        this.accountAuditActive = ''
    }

    callApiTabAccessLog(idClient) {
        const clientId = {}
        const result = '{"clientId":"' + idClient + '"}'
        clientId[result] = true

        const clientIdInfor = {}
        const resultidClient = this.idClient
        clientIdInfor[resultidClient] = true

        const resourceDataAccessLog = {
            actions: [],
            status: {
                access_log: {
                    paths: clientId,
                },
                clientMail: {
                    paths: {
                        '{}': true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    map: clientIdInfor,
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    const clientInfoRespon = this.clientInfo = success['response']['client']['map'][resultidClient]
                    if (clientInfoRespon.familyName) {
                        this.operatorNameClient = clientInfoRespon.familyName + ' ' + clientInfoRespon.firstName
                    } else {
                        this.operatorNameClient = clientInfoRespon.firstName
                    }
                    const listlistAccessLogData = this.listAccessLog = success['response']['access_log']['paths'][result]
                    const listStaffAccessLogData = this.listStaffAccessLog = success['response']['staff']['paths']['{}']
                    const operatorNameClient = this.operatorNameClient
                    listlistAccessLogData.forEach(function(AccessLogItem) {
                        listStaffAccessLogData.forEach(function(StaffAccessLogItem) {
                            if (AccessLogItem.staffId === StaffAccessLogItem._id) {
                                if (StaffAccessLogItem.familyName) {
                                    AccessLogItem.operator = StaffAccessLogItem.firstName + StaffAccessLogItem.familyName
                                } else {
                                    AccessLogItem.operator = StaffAccessLogItem.firstName
                                }
                                AccessLogItem.operatorDeleted = StaffAccessLogItem.deleted
                            }
                        })
                        AccessLogItem.operatorNameClient = operatorNameClient ? operatorNameClient : ''
                        AccessLogItem.modal = 'AccessLog'
                    })
                },
            )
        })
    }

    selectTabAccountLog(idClient) {
        this.accountLog = 'active'
        this.accessLog = 'hidden'
        this.accessAuditActive = ''
        this.accountAuditActive = 'accountAuditActive'

        const clientId = {}
        const resultAccountLog = '{"clientId":"' + idClient + '"}'
        clientId[resultAccountLog] = true

        const clientIdInfor = {}
        const resultidClient = this.idClient
        clientIdInfor[resultidClient] = true

        const resourceDataAccountLog = {
            actions: [],
            status: {
                account_log: {
                    paths: clientId,
                },
                clientMail: {
                    paths: {
                        '{}': true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    map: clientIdInfor,
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccountLog, tokenReNew).subscribe(
                success => {
                    const clientInfoRespon = this.clientInfo = success['response']['client']['map'][resultidClient]
                    if (clientInfoRespon.familyName) {
                        this.operatorNameClient = clientInfoRespon.familyName + ' ' + clientInfoRespon.firstName
                    } else {
                        this.operatorNameClient = clientInfoRespon.firstName
                    }
                    const listlistAccountLogData = this.listAccountLog = success['response']['account_log']['paths'][resultAccountLog]
                    const listStaffAccountLogData = this.listStaffAccountLog = success['response']['staff']['paths']['{}']
                    const operatorNameClient = this.operatorNameClient
                    listlistAccountLogData.forEach(function(AccountLogItem) {
                        listStaffAccountLogData.forEach(function(StaffAccountLogItem) {
                            if (AccountLogItem.staffId === StaffAccountLogItem._id) {
                                if (StaffAccountLogItem.familyName) {
                                    AccountLogItem.operator = StaffAccountLogItem.firstName + StaffAccountLogItem.familyName
                                } else {
                                    AccountLogItem.operator = StaffAccountLogItem.firstName
                                }
                                AccountLogItem.operatorDeleted = StaffAccountLogItem.deleted
                            }
                        })
                        AccountLogItem.operatorNameClient = operatorNameClient ? operatorNameClient : ''
                        AccountLogItem.modal = 'AccountLog'
                    })
                },
            )
        })


    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/audit/audit.component.ts